















import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldSearchAddress'

  vue:
    props: ['value', 'errors', 'placeholder', 'disabled', 'replace']

    data: ->
      value_: @value
      search: ''

    mounted: ->
      if @isAddressValid @value
        @search = "#{@value.street}, #{@value.city}, #{@value.state}, #{@value.country}"

    methods:
      hiSearch: (place) ->
        location = @placeToRegionalLocation place
        @search = "#{location.street}, #{location.city}, #{location.state}, #{location.country}"
        @value.street = location.street
        @value.city = location.city
        @value.state = location.state
        @value.zip = location.zip
        @value.country = location.country
        @$emit 'input', @value
        @$emit 'blur', @value

      placeToRegionalLocation: (place) ->
        { name, address_components, geometry } = place
        return unless address_components
        streetName = @extractAddressComponent address_components, 'route'
        streetNumber = @extractAddressComponent address_components, 'street_number'
        street = "#{streetNumber} #{streetName}".trim()
        city = @extractAddressComponent address_components, 'locality'
        city ||= @extractAddressComponent address_components, 'administrative_area_level_2'
        state = @extractAddressComponent address_components, 'administrative_area_level_1', 'short_name'
        zip = @extractAddressComponent address_components, 'postal_code'
        country = @extractAddressComponent address_components, 'country', 'short_name'
        { street, city, state, zip, country }

      extractAddressComponent: (addressComponents, componentType, fromProp = 'long_name') ->
        return component[fromProp].trim() for component in addressComponents when componentType in component.types
        ''

      isAddressValid: (address) ->
        { street, city, state, zip, country } = address
        !!address and !!street and !!city and !!state and !!zip and !!country

    watch:
      value: (v) ->
        @value_ = v

export default VueOptions.vue settings
